import {Realtime, Rest} from 'ably';
import {store} from '../store';
import {API_ABLY_AUTH} from '../configs/apis';

const AblyService = {
  authorize() {
    const state = store.getState();
    const {auth: {token}} = state;
    const authOptions = {
      authUrl: `${process.env.API_URL}/${API_ABLY_AUTH}`,
      authHeaders: {
        Authorization: `Bearer ${token}`,
      },
    };

    this.realtime = new Realtime(authOptions);
    this.rest = new Rest(authOptions);
  },
};
export default AblyService;

